module.exports = __webpack_public_path__ + "assets/img/img144.91d403c2.png";